import { cva, cx } from "class-variance-authority";

const Spinner = ({
  variant = "default",
  className,
}: {
  variant?: "default" | "button";
  className?: string;
}) => {
  const spinnerVariant = cva(
    "p-0 m-0 animate-spin box-border inline border-b-transparent rounded-full",
    {
      variants: {
        variant: {
          default: "size-12 border-4 border-(--primary-color)",
          button: "size-5 border-2 border-white",
        },
      },
      defaultVariants: {
        variant: "default",
      },
    }
  );
  return <span className={cx(spinnerVariant({ variant }), className)}></span>;
};

export default Spinner;
